import React, { ReactElement, useEffect } from 'react';
import { Button, LoaderButton } from 'idsk-react-components';
import { ConfirmModal } from 'slovlex-idsk-react-components';
import { useClient, useClientStatusContext } from '../../../../../../context/ClientStatusContext';
import { useSuccessMessageContext } from '../../../../../../context/SuccessMessageContext';
import PracovnyKrokRequest from '../../../../../../model/pracovnyKrok/PracovnyKrokRequest';
import { odoslatNaSchvalenie } from '../../../../../../client/pracovnyKrok/schvalenieGestoraClient';
import splitCisloLegMaterialu from '../../../../../../function/splitCisloLegMaterialu';
import LegislativnyMaterialItem
  from '../../../../../../model/pracovnyKrok/LegislativnyMaterialItem';
import {
  usePracovnyKrokLegislativnyMaterialContext,
} from '../../../../../../context/PracovnyKrokLegislativnyMaterialContext';

interface Props {
  legMaterial: LegislativnyMaterialItem;
  pracovnyKrok: PracovnyKrokRequest;
  reloadDetail?: () => void;
  reloadPracovneKroky?: () => void;
  setIsDropdownOpened: (isDropdownOpened: boolean) => void,
}

const OdoslatNaUvsr = ({
  legMaterial,
  pracovnyKrok,
  reloadDetail,
  reloadPracovneKroky,
  setIsDropdownOpened,
}: Props): ReactElement => {
  const {
    clearMessages,
    displaySuccess,
  } = useSuccessMessageContext();
  const { clearStatus } = useClientStatusContext();
  const { setMaterial, setLoadingMaterial } = usePracovnyKrokLegislativnyMaterialContext();
  const { type, year, index } = splitCisloLegMaterialu(legMaterial.cisloLegislativnehoMaterialu);

  const {
    wrapClient: odoslatNaSchvalenieClient,
    status: odoslatNaSchvalenieStatus,
  } = useClient(odoslatNaSchvalenie);

  const odoslatNaSchvalenieGestora = async (): Promise<void> => {
    await odoslatNaSchvalenieClient(type, year, index, pracovnyKrok.pracovnyKrokId);

    if (reloadDetail !== undefined) {
      reloadDetail();
    }

    if (reloadPracovneKroky !== undefined) {
      reloadPracovneKroky();
    }

    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  useEffect(
    () => setMaterial(legMaterial),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [legMaterial?.uuid, legMaterial?.typ,
      legMaterial?.cisloLegislativnehoMaterialu, setMaterial],
  );

  useEffect(() => {
    setLoadingMaterial(odoslatNaSchvalenieStatus?.loading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [odoslatNaSchvalenieStatus?.loading]);

  const clearStatusAndMessages = (): void => {
    clearStatus();
    clearMessages();
  };

  return (
    <ConfirmModal
      question='Naozaj si prajete vykonať pracovný krok "Odoslať na ÚV SR na schválenie gestora"?'
      description={'Po vykonaní tohto pracovného kroku sa ukončí aktuálne štádium a odstránia sa '
              + 'z Vášho zásobníka práce pracovné kroky, ktoré patria do aktuálneho štádia tohto '
              + 'materiálu a spustí sa nové štádium.'}
      cancelButtonText="Nie"
      confirmButton={
            (
              <Button
                buttonStyle="action"
                size="large"
              >
                Áno
              </Button>
            )
          }
      openButton={(
        <LoaderButton
          className="pracovny-krok__button"
          buttonStyle="link"
          size="small"
          onClick={() => {
            clearStatusAndMessages();
            setIsDropdownOpened(false);
          }}
          loading={odoslatNaSchvalenieStatus.loading}
          disableOutsideClickWhileLoading
        >
          {pracovnyKrok.nazov}
        </LoaderButton>
          )}
      doAfterConfirm={odoslatNaSchvalenieGestora}
    />
  );
};

export default OdoslatNaUvsr;
